export const convertTplsToOptions = (tpls) => {
  if (!tpls) return [];

  return tpls.map((d) => ({
    display: d.general?.content?.title || d.kp_content_type,
    value: d.kp_content_type,
  }));
};
